import React, { useState, useEffect } from 'react';
import {
  FaSync, FaPlus, FaEdit, FaTrash, FaSearch,
  FaMoneyBillWave, FaTimes, FaFilter
} from 'react-icons/fa';
import axiosInstance from '../utils/axiosInstance';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

const AY_ADLARI = ['','Ocak','Şubat','Mart','Nisan','Mayıs','Haziran',
  'Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];

const KATEGORİLER = [
  { value: 'odeme',     label: 'Ödeme',          renk: '#93c5fd' },
  { value: 'maas',      label: 'Maaş / Prim',     renk: '#4ade80' },
  { value: 'marketing', label: 'Marketing / Aff', renk: '#f59e0b' },
];

const KAT_STIL = {
  odeme:     { color: '#93c5fd', bg: 'rgba(147,197,253,0.08)', border: 'rgba(147,197,253,0.2)' },
  maas:      { color: '#4ade80', bg: 'rgba(74,222,128,0.08)',  border: 'rgba(74,222,128,0.2)'  },
  marketing: { color: '#f59e0b', bg: 'rgba(245,158,11,0.08)',  border: 'rgba(245,158,11,0.2)'  },
};

const BOSH = {
  tarih: dayjs().format('YYYY-MM-DD'), kategori: 'odeme',
  tur: '', yontem: '', gonderen: '', alici: '',
  miktarUSDT: 0, miktarTL: 0, komisyon: 0, toplam: 0, info: '',
};

const fmt = (n) => new Intl.NumberFormat('tr-TR', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
}).format(n ?? 0);

const OdemeYonetimi = () => {
  const bugun = dayjs();
  const [kayitlar,      setKayitlar]      = useState([]);
  const [ozet,          setOzet]          = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [search,        setSearch]        = useState('');
  const [filtre,        setFiltre]        = useState({ kategori: '', ay: bugun.month() + 1, yil: bugun.year() });
  const [modal,         setModal]         = useState(null);
  const [secili,        setSecili]        = useState(null);
  const [form,          setForm]          = useState(BOSH);
  const [kasaListesi,   setKasaListesi]   = useState([]);
  const [yontemListesi, setYontemListesi] = useState([]);
  const [aktifKat,      setAktifKat]      = useState(null);

  useEffect(() => {
    axiosInstance.get('/rapor/kasalar?ay=1&yil=2026')
      .then(r => setKasaListesi(r.data.map(k => k.kasa).filter(Boolean)))
      .catch(() => {});
    axiosInstance.get('/odeme-yontemi/all?aktif=true')
      .then(r => setYontemListesi(r.data.map(y => y._id)))
      .catch(() => {});
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const p = new URLSearchParams(
        Object.fromEntries(Object.entries(filtre).filter(([, v]) => v))
      );
      const [listRes, ozetRes] = await Promise.all([
        axiosInstance.get(`/odeme/all?${p}`),
        axiosInstance.get(`/odeme/ozet?ay=${filtre.ay}&yil=${filtre.yil}`),
      ]);
      setKayitlar(listRes.data);
      setOzet(ozetRes.data);
    } catch { toast.error('Veriler yüklenemedi!'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, [filtre.kategori, filtre.ay, filtre.yil]);

  const handleEkle = () => { setForm(BOSH); setSecili(null); setModal('form'); };
  const handleDuzenle = (k) => {
    setSecili(k);
    setForm({
      tarih: dayjs(k.tarih?.full).format('YYYY-MM-DD'),
      kategori: k.kategori, tur: k.tur, yontem: k.yontem,
      gonderen: k.gonderen ?? '', alici: k.alici ?? '',
      miktarUSDT: k.miktarUSDT, miktarTL: k.miktarTL,
      komisyon: k.komisyon, toplam: k.toplam, info: k.info ?? '',
    });
    setModal('form');
  };
  const handleKaydet = async () => {
    try {
      if (!secili) { await axiosInstance.post('/odeme/add', form); toast.success('Kayıt eklendi.'); }
      else { await axiosInstance.patch(`/odeme/update/${secili._id}`, form); toast.success('Güncellendi.'); }
      setModal(null); fetchData();
    } catch { toast.error('İşlem başarısız!'); }
  };
  const handleSil = async (id) => {
    if (!window.confirm('Silinsin mi?')) return;
    try { await axiosInstance.delete(`/odeme/delete/${id}`); toast.success('Silindi.'); fetchData(); }
    catch { toast.error('Silme başarısız!'); }
  };

  const ozetKatMap = {};
  const ozetTurMap = {};
  ozet.forEach(o => {
    const kat = o._id?.kategori ?? '?';
    const tur = o._id?.tur ?? '?';
    if (!ozetKatMap[kat]) ozetKatMap[kat] = { usdtToplam: 0, tlToplam: 0, komisyon: 0, net: 0, sayi: 0 };
    ozetKatMap[kat].usdtToplam += o.toplamUSDT     ?? 0;
    ozetKatMap[kat].tlToplam   += o.toplamTL       ?? 0;
    ozetKatMap[kat].komisyon   += o.toplamKomisyon ?? 0;
    ozetKatMap[kat].net        += o.toplamNet      ?? 0;
    ozetKatMap[kat].sayi       += o.islemSayisi    ?? 0;
    const key = `${kat}||${tur}`;
    if (!ozetTurMap[key]) ozetTurMap[key] = { kat, tur, net: 0, sayi: 0 };
    ozetTurMap[key].net  += o.toplamNet   ?? 0;
    ozetTurMap[key].sayi += o.islemSayisi ?? 0;
  });

  const filtered = kayitlar.filter(k => {
    if (aktifKat && k.kategori !== aktifKat) return false;
    if (!search) return true;
    return ['alici','tur','yontem','gonderen'].some(f =>
      (k[f] ?? '').toLowerCase().includes(search.toLowerCase())
    );
  });

  const katLabel = (v) => KATEGORİLER.find(c => c.value === v)?.label ?? v;
  const toplamNet = filtered.reduce((s, k) => s + (k.toplam   ?? 0), 0);
  const toplamTL  = filtered.reduce((s, k) => s + (k.miktarTL ?? 0), 0);

  return (
    <div style={S.page}>
      <div style={S.glow1} />
      <div style={S.glow2} />

      {/* HEADER */}
      <div style={S.header}>
        <div>
          <h2 style={S.hTitle}>
            <div style={S.hIcon}><FaMoneyBillWave /></div>
            Ödeme Yönetimi
          </h2>
          <p style={S.hSub}>{AY_ADLARI[filtre.ay]} {filtre.yil} • {kayitlar.length} kayıt</p>
        </div>
        <div style={S.hControls}>
          <select style={S.sel} value={filtre.kategori} onChange={e => setFiltre(p => ({ ...p, kategori: e.target.value }))}>
            <option value="">Tüm Kategoriler</option>
            {KATEGORİLER.map(k => <option key={k.value} value={k.value}>{k.label}</option>)}
          </select>
          <select style={S.sel} value={filtre.ay} onChange={e => setFiltre(p => ({ ...p, ay: Number(e.target.value) }))}>
            {AY_ADLARI.slice(1).map((ad, i) => <option key={i+1} value={i+1}>{ad}</option>)}
          </select>
          <select style={S.sel} value={filtre.yil} onChange={e => setFiltre(p => ({ ...p, yil: Number(e.target.value) }))}>
            {[2024,2025,2026,2027].map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button style={S.refreshBtn} onClick={fetchData}>
            <FaSync style={loading ? { animation: 'spin 1s linear infinite' } : {}} />
          </button>
          <button style={S.addBtn} onClick={handleEkle}>
            <FaPlus style={{ fontSize: '0.75rem' }} /> Yeni Ödeme
          </button>
        </div>
      </div>

      {/* KATEGORİ KARTLARI */}
      <div style={S.katGrid}>
        {KATEGORİLER.map(({ value, label, renk }) => {
          const t = ozetKatMap[value];
          if (!t) return null;
          const isActive = aktifKat === value;
          const stil = KAT_STIL[value];
          const turler = Object.values(ozetTurMap)
            .filter(x => x.kat === value)
            .sort((a, b) => b.net - a.net);
          return (
            <div key={value}
              style={{
                ...S.katCard,
                border: `1px solid ${isActive ? renk : stil.border}`,
                boxShadow: isActive ? `0 0 28px ${renk}20` : '0 4px 20px rgba(0,0,0,0.2)',
              }}
              onClick={() => setAktifKat(isActive ? null : value)}
            >
              <div style={{ ...S.katStripe, background: renk }} />
              <div style={S.katBody}>
                <div style={S.katTopRow}>
                  <span style={{ ...S.katBadge, color: renk, background: `${renk}15`, border: `1px solid ${renk}30` }}>{label}</span>
                  <span style={{ ...S.katSayi, color: renk }}>{t.sayi} işlem</span>
                </div>
                <p style={{ ...S.katNet, color: renk }}>{fmt(t.net)}<span style={S.katTL}> TL</span></p>
                {t.usdtToplam > 0 && <p style={S.katUsdt}>{fmt(t.usdtToplam)} USDT</p>}
                {turler.length > 0 && (
                  <div style={S.turList}>
                    {turler.slice(0, 4).map(tx => (
                      <div key={tx.tur} style={S.turRow}>
                        <div style={{ ...S.turBar, width: `${(tx.net / t.net) * 100}%`, background: renk }} />
                        <span style={S.turLabel}>{tx.tur}</span>
                        <span style={{ ...S.turVal, color: renk }}>{fmt(tx.net)}</span>
                      </div>
                    ))}
                    {turler.length > 4 && <p style={S.turMore}>+{turler.length - 4} daha</p>}
                  </div>
                )}
              </div>
              {isActive && (
                <div style={S.activeIndicator}>
                  <FaFilter style={{ fontSize: '0.6rem' }} /> Filtreleniyor
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* TABLO PANELİ */}
      <div style={S.tablePanel}>
        <div style={S.searchBar}>
          <div style={S.searchLeft}>
            <FaSearch style={S.searchIco} />
            <input style={S.searchInp} placeholder="Alıcı, tür veya yöntem ara..."
              value={search} onChange={e => setSearch(e.target.value)} />
            {search && (
              <button style={S.clearSearch} onClick={() => setSearch('')}><FaTimes /></button>
            )}
          </div>
          <div style={S.searchRight}>
            {aktifKat && (
              <button style={{
                ...S.filterChip,
                color: KAT_STIL[aktifKat]?.color,
                border: `1px solid ${KAT_STIL[aktifKat]?.border}`,
                background: KAT_STIL[aktifKat]?.bg,
              }} onClick={() => setAktifKat(null)}>
                {katLabel(aktifKat)} <FaTimes style={{ fontSize: '0.65rem' }} />
              </button>
            )}
            <span style={S.rowCount}>{filtered.length} satır</span>
          </div>
        </div>

        <div style={{ overflowX: 'auto' }}>
          {loading ? (
            <div style={S.loadWrap}><div style={S.spinner} /></div>
          ) : (
            <table style={S.table}>
              <thead>
                <tr>
                  {['TARİH','KATEGORİ','YÖNTEM','GÖNDERİCİ','ALICI','USDT','TL TUTAR','KOMİSYON','TOPLAM',''].map(h => (
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={10} style={S.noData}>Kayıt bulunamadı</td></tr>
                ) : filtered.map((k, i) => {
                  const stil = KAT_STIL[k.kategori] ?? KAT_STIL.odeme;
                  return (
                    <tr key={k._id} style={{ ...S.tr, animationDelay: `${i * 20}ms` }}>
                      <td style={{ ...S.td, color: '#64748b' }}>{dayjs(k.tarih?.full).format('DD.MM.YYYY')}</td>
                      <td style={S.td}>
                        <span style={{ ...S.pill, color: stil.color, background: stil.bg, border: `1px solid ${stil.border}` }}>
                          {katLabel(k.kategori)}
                        </span>
                      </td>
                      <td style={{ ...S.td, color: '#94a3b8' }}>{k.yontem ?? '—'}</td>
                      <td style={{ ...S.td, color: '#64748b' }}>{k.gonderen ?? '—'}</td>
                      <td style={{ ...S.td, color: '#f1f5f9', fontWeight: 600 }}>{k.alici ?? '—'}</td>
                      <td style={{ ...S.td, color: '#fbbf24' }}>{fmt(k.miktarUSDT)}</td>
                      <td style={{ ...S.td, color: '#94a3b8' }}>{fmt(k.miktarTL)}</td>
                      <td style={{ ...S.td, color: '#f87171' }}>{fmt(k.komisyon)}</td>
                      <td style={{ ...S.td, fontWeight: 700, color: stil.color }}>{fmt(k.toplam)}</td>
                      <td style={S.td}>
                        <button style={S.editBtn} onClick={() => handleDuzenle(k)} title="Düzenle"><FaEdit /></button>
                        <button style={S.delBtn}  onClick={() => handleSil(k._id)}  title="Sil"><FaTrash /></button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              {filtered.length > 0 && (
                <tfoot>
                  <tr style={S.tfootRow}>
                    <td colSpan={5} style={{ ...S.td, color: '#f27127', fontWeight: 800 }}>TOPLAM</td>
                    <td style={{ ...S.td, color: '#fbbf24', fontWeight: 700 }} />
                    <td style={{ ...S.td, color: '#94a3b8', fontWeight: 700 }}>{fmt(toplamTL)}</td>
                    <td style={S.td} />
                    <td style={{ ...S.td, color: '#f27127', fontWeight: 900 }}>{fmt(toplamNet)}</td>
                    <td style={S.td} />
                  </tr>
                </tfoot>
              )}
            </table>
          )}
        </div>
      </div>

      {/* MODAL */}
      {modal === 'form' && (
        <OdemeModal
          secili={secili}
          form={form}
          setForm={setForm}
          kasaListesi={kasaListesi}
          yontemListesi={yontemListesi}
          onKaydet={handleKaydet}
          onKapat={() => setModal(null)}
        />
      )}

      <style>{`
        @keyframes spin   { to { transform: rotate(360deg); } }
        @keyframes fadeUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
        @keyframes rowIn  { from { opacity:0; transform:translateX(-6px); } to { opacity:1; transform:translateX(0); } }
        tbody tr { animation: rowIn 0.3s ease both; }
        tbody tr:hover td { background: rgba(255,255,255,0.018) !important; }
        select option { background: #0d0f14; }
        input::placeholder { color: #1e293b; }
        input[type=date]::-webkit-calendar-picker-indicator { filter: invert(0.3); }
      `}</style>
    </div>
  );
};

/* ─── Modal ──────────────────────────────────────────────────────── */
const OdemeModal = ({ secili, form, setForm, kasaListesi, yontemListesi, onKaydet, onKapat }) => {
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  return (
    <div style={M.overlay} onClick={onKapat}>
      <div style={M.box} onClick={e => e.stopPropagation()}>
        <div style={M.header}>
          <div style={M.headerLeft}>
            <div style={{ ...M.hIcon, background: secili ? 'rgba(59,130,246,0.15)' : 'rgba(242,113,39,0.15)', color: secili ? '#3b82f6' : '#f27127' }}>
              {secili ? <FaEdit /> : <FaPlus />}
            </div>
            <div>
              <h3 style={M.title}>{secili ? 'Kaydı Düzenle' : 'Yeni Ödeme Ekle'}</h3>
              <p style={M.sub}>{secili ? 'Mevcut kaydı güncelle' : 'Yeni bir ödeme kaydı oluştur'}</p>
            </div>
          </div>
          <button style={M.closeBtn} onClick={onKapat}><FaTimes /></button>
        </div>

        <div style={M.body}>
          <div style={M.section}>
            <label style={M.sectionLabel}>Kategori</label>
            <div style={M.katRow}>
              {KATEGORİLER.map(k => {
                const isActive = form.kategori === k.value;
                return (
                  <button key={k.value}
                    style={{
                      ...M.katBtn,
                      color:      isActive ? k.renk : '#334155',
                      background: isActive ? `${k.renk}12` : 'transparent',
                      border:     `1px solid ${isActive ? `${k.renk}40` : '#1e2530'}`,
                    }}
                    onClick={() => set('kategori', k.value)}
                  >
                    <span style={{ ...M.katDot, background: k.renk }} />
                    {k.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div style={M.divider} />

          <div style={M.grid}>
            <FG label="Tarih">
              <input style={M.inp} type="date" value={form.tarih}
                onChange={e => set('tarih', e.target.value)} />
            </FG>

            <FG label="Tür">
              <input style={M.inp} list="tur-list" value={form.tur}
                onChange={e => set('tur', e.target.value)}
                placeholder="PERSONEL MAAŞ, MARKETİNG..." />
              <datalist id="tur-list">
                {['PERSONEL MAAŞ','YÖNETİCİ MAAŞ','PRİM','MARKETİNG','AFFİLİATE','YAZILIM','ALTYAPI','DİĞER']
                  .map(t => <option key={t} value={t} />)}
              </datalist>
            </FG>

            <FG label="Yöntem / Kasa">
              <select style={M.inp} value={form.yontem} onChange={e => set('yontem', e.target.value)}>
                <option value="">— Seçiniz —</option>
                <optgroup label="Kasalar">
                  {kasaListesi.map(k => <option key={k} value={k}>{k}</option>)}
                </optgroup>
                {yontemListesi.length > 0 && (
                  <optgroup label="Ödeme Yöntemleri">
                    {yontemListesi.map(y => <option key={y} value={y}>{y}</option>)}
                  </optgroup>
                )}
              </select>
            </FG>

            <FG label="Gönderen">
              <input style={M.inp} value={form.gonderen}
                onChange={e => set('gonderen', e.target.value)} placeholder="Gönderen kişi / firma" />
            </FG>

            <FG label="Alıcı">
              <input style={M.inp} value={form.alici}
                onChange={e => set('alici', e.target.value)} placeholder="Alıcı kişi / firma" />
            </FG>

            <FG label="Miktar USDT">
              <input style={M.inp} type="number" value={form.miktarUSDT}
                onChange={e => set('miktarUSDT', parseFloat(e.target.value) || 0)} />
            </FG>

            <FG label="Miktar TL">
              <input style={M.inp} type="number" value={form.miktarTL}
                onChange={e => set('miktarTL', parseFloat(e.target.value) || 0)} />
            </FG>

            <FG label="Komisyon">
              <input style={M.inp} type="number" value={form.komisyon}
                onChange={e => set('komisyon', parseFloat(e.target.value) || 0)} />
            </FG>

            <FG label="Toplam">
              <input style={{ ...M.inp, color: '#4ade80', fontWeight: 700 }} type="number" value={form.toplam}
                onChange={e => set('toplam', parseFloat(e.target.value) || 0)} />
            </FG>

            <div style={{ gridColumn: '1 / -1' }}>
              <FG label="Not / Açıklama">
                <input style={M.inp} value={form.info}
                  onChange={e => set('info', e.target.value)} placeholder="Opsiyonel not..." />
              </FG>
            </div>
          </div>
        </div>

        <div style={M.footer}>
          <button style={M.cancelBtn} onClick={onKapat}>İptal</button>
          <button style={M.saveBtn}   onClick={onKaydet}>{secili ? 'Güncelle' : 'Kaydet'}</button>
        </div>
      </div>
    </div>
  );
};

/* ─── Form Group ─────────────────────────────────────────────────── */
const FG = ({ label, children }) => (
  <div>
    <label style={{ color: '#334155', fontSize: '0.65rem', fontWeight: 700,
      textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', marginBottom: 7 }}>
      {label}
    </label>
    {children}
  </div>
);

/* ══════════ STYLES ══════════════════════════════════════════════════ */
const S = {
  page: { padding: '28px', minHeight: '100vh', backgroundColor: '#07080b', fontFamily: "'Plus Jakarta Sans', sans-serif", color: '#e2e8f0', position: 'relative', overflow: 'hidden' },
  glow1: { position: 'fixed', top: -200, right: -100, width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(242,113,39,0.05) 0%, transparent 65%)', pointerEvents: 'none', zIndex: 0 },
  glow2: { position: 'fixed', bottom: -150, left: -80, width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(147,197,253,0.04) 0%, transparent 65%)', pointerEvents: 'none', zIndex: 0 },
  header: { position: 'relative', zIndex: 1, background: 'linear-gradient(105deg, #13151a 0%, #1a1d24 100%)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 18, padding: '20px 26px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 14, boxShadow: '0 12px 40px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.04)' },
  hIcon: { width: 40, height: 40, borderRadius: 12, background: 'rgba(242,113,39,0.12)', color: '#f27127', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginRight: 12, fontSize: '1rem', flexShrink: 0 },
  hTitle: { color: '#fff', fontSize: '1.4rem', fontWeight: 800, display: 'flex', alignItems: 'center', margin: 0 },
  hSub: { color: '#334155', fontSize: '0.8rem', margin: '4px 0 0 52px' },
  hControls: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' },
  sel: { background: '#0d0f14', border: '1px solid #1e2530', borderRadius: 10, color: '#94a3b8', padding: '8px 12px', fontSize: '0.8rem', cursor: 'pointer' },
  refreshBtn: { background: 'rgba(242,113,39,0.1)', border: '1px solid rgba(242,113,39,0.2)', color: '#f27127', borderRadius: 10, width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
  addBtn: { background: 'linear-gradient(135deg, #f27127, #ff9a44)', color: '#fff', border: 'none', borderRadius: 10, padding: '9px 16px', fontWeight: 700, fontSize: '0.82rem', display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer', boxShadow: '0 4px 14px rgba(242,113,39,0.3)' },
  katGrid: { position: 'relative', zIndex: 1, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 20 },
  katCard: { borderRadius: 16, overflow: 'hidden', cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s', position: 'relative', background: 'linear-gradient(135deg, rgba(19,21,26,0.98), rgba(14,16,20,1))' },
  katStripe: { height: 3, width: '100%' },
  katBody: { padding: '16px 20px 18px' },
  katTopRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 },
  katBadge: { fontSize: '0.65rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em', padding: '3px 10px', borderRadius: 6 },
  katSayi: { fontSize: '0.68rem', fontWeight: 600 },
  katNet: { fontSize: '1.6rem', fontWeight: 900, margin: '0 0 2px', lineHeight: 1.1, fontVariantNumeric: 'tabular-nums' },
  katTL: { fontSize: '0.85rem', fontWeight: 600, opacity: 0.7 },
  katUsdt: { color: '#fbbf24', fontSize: '0.75rem', margin: '2px 0 10px', fontVariantNumeric: 'tabular-nums' },
  turList: { marginTop: 12, display: 'flex', flexDirection: 'column', gap: 5 },
  turRow: { display: 'flex', alignItems: 'center', gap: 8, position: 'relative' },
  turBar: { position: 'absolute', left: 0, bottom: 0, height: 1, borderRadius: 1, opacity: 0.3, transition: 'width 0.4s ease' },
  turLabel: { color: '#334155', fontSize: '0.65rem', flex: 1, paddingBottom: 3 },
  turVal: { fontSize: '0.68rem', fontWeight: 700, fontVariantNumeric: 'tabular-nums' },
  turMore: { color: '#1e293b', fontSize: '0.62rem', margin: '4px 0 0', textAlign: 'right' },
  activeIndicator: { position: 'absolute', top: 10, right: 12, color: '#94a3b8', fontSize: '0.6rem', display: 'flex', alignItems: 'center', gap: 4 },
  tablePanel: { position: 'relative', zIndex: 1, background: 'linear-gradient(135deg, rgba(19,21,26,0.98), rgba(14,16,20,1))', border: '1px solid rgba(255,255,255,0.05)', borderRadius: 18, overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.25)' },
  searchBar: { padding: '14px 18px', borderBottom: '1px solid #0d0f14', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' },
  searchLeft: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, minWidth: 240 },
  searchIco: { position: 'absolute', left: 13, color: '#1e2530', fontSize: '0.8rem' },
  searchInp: { width: '100%', padding: '9px 36px', background: '#0d0f14', border: '1px solid #1a1e28', borderRadius: 10, color: '#94a3b8', fontSize: '0.82rem', boxSizing: 'border-box' },
  clearSearch: { position: 'absolute', right: 10, background: 'none', border: 'none', color: '#334155', cursor: 'pointer', padding: 4 },
  searchRight: { display: 'flex', alignItems: 'center', gap: 10 },
  filterChip: { display: 'flex', alignItems: 'center', gap: 6, padding: '4px 10px', borderRadius: 7, fontSize: '0.68rem', fontWeight: 700, cursor: 'pointer' },
  rowCount: { color: '#1e293b', fontSize: '0.72rem' },
  loadWrap: { display: 'flex', justifyContent: 'center', padding: 60 },
  spinner: { width: 34, height: 34, borderRadius: '50%', border: '3px solid #1a1e28', borderTopColor: '#f27127', animation: 'spin 0.8s linear infinite' },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: 900 },
  th: { padding: '10px 14px', color: '#1e2530', fontSize: '0.6rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', borderBottom: '1px solid #0d0f14', textAlign: 'left', whiteSpace: 'nowrap', background: 'rgba(0,0,0,0.2)' },
  tr: { borderBottom: '1px solid rgba(255,255,255,0.02)' },
  td: { padding: '11px 14px', color: '#475569', fontSize: '0.82rem', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' },
  noData: { textAlign: 'center', padding: 60, color: '#1e293b', fontStyle: 'italic' },
  pill: { padding: '3px 9px', borderRadius: 5, fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.05em' },
  editBtn: { width: 28, height: 28, borderRadius: 7, border: 'none', background: 'rgba(59,130,246,0.1)', color: '#3b82f6', marginRight: 5, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem' },
  delBtn:  { width: 28, height: 28, borderRadius: 7, border: 'none', background: 'rgba(248,113,113,0.1)', color: '#f87171', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem' },
  tfootRow: { borderTop: '1px solid #1a1e28', background: 'rgba(255,255,255,0.015)' },
};

const M = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', backdropFilter: 'blur(8px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: 20 },
  box: { background: 'linear-gradient(145deg, #13151a, #0f1115)', border: '1px solid #1e2530', borderRadius: 20, width: '100%', maxWidth: 660, maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 30px 60px rgba(0,0,0,0.6)', animation: 'fadeUp 0.25s ease' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px', borderBottom: '1px solid #1a1e28', position: 'sticky', top: 0, background: '#13151a', zIndex: 1 },
  headerLeft: { display: 'flex', alignItems: 'center', gap: 14 },
  hIcon: { width: 42, height: 42, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', flexShrink: 0 },
  title: { color: '#f1f5f9', fontSize: '1rem', fontWeight: 800, margin: 0 },
  sub: { color: '#334155', fontSize: '0.72rem', margin: '3px 0 0' },
  closeBtn: { background: 'rgba(255,255,255,0.04)', border: '1px solid #1e2530', color: '#475569', borderRadius: 9, width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '0.85rem' },
  body: { padding: '22px 24px' },
  section: { marginBottom: 18 },
  sectionLabel: { color: '#334155', fontSize: '0.65rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', marginBottom: 10 },
  katRow: { display: 'flex', gap: 8 },
  katBtn: { flex: 1, padding: '10px 8px', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, transition: 'all 0.15s' },
  katDot: { width: 7, height: 7, borderRadius: 2, flexShrink: 0 },
  divider: { height: 1, background: '#1a1e28', margin: '0 0 18px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 },
  inp: { width: '100%', padding: '10px 13px', background: '#0a0c10', border: '1px solid #1a1e28', borderRadius: 10, color: '#94a3b8', fontSize: '0.85rem', boxSizing: 'border-box' },
  footer: { padding: '16px 24px', borderTop: '1px solid #1a1e28', display: 'flex', gap: 10, justifyContent: 'flex-end' },
  cancelBtn: { padding: '10px 20px', borderRadius: 10, background: '#1a1e28', color: '#475569', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem' },
  saveBtn: { padding: '10px 24px', borderRadius: 10, background: 'linear-gradient(135deg, #f27127, #ff9a44)', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.85rem', boxShadow: '0 4px 14px rgba(242,113,39,0.3)' },
};

export default OdemeYonetimi;
